import React from "react";
import styled from "styled-components";
import { ThemeProps } from "../styles/theme";

const StrikethroughSpan = styled.s<ThemeProps>`
    color: ${props => props.theme.secondaryText};
`;

const HighlightMark = styled.mark<ThemeProps>`
    background-color: ${props => props.theme.accentColor}33;
    color: ${props => props.theme.primaryForeground};
    border-radius: 2px;
    padding: 0 2px;
`;

const UnderlineSpan = styled.span<ThemeProps>`
    text-decoration: underline;
    text-decoration-color: ${props => props.theme.accentColor};
    text-underline-offset: 3px;
`;

const COLOR_VALUES: Record<string, string> = {
    red:   '#e05555',
    blue:  '#4a9eff',
    green: '#4caf50',
    gold:  '#c9a227',
};

const ColorSpan = styled.span<{ $color: string }>`
    color: ${props => props.$color};
`;

export function renderInlineMarkup(text: string): React.ReactNode {
    const parts = text.split(/(\*\*\*.+?\*\*\*|\*\*.+?\*\*|\*.+?\*|~~.+?~~|==.+?==|(?<!_)_[^_]+?_(?!_)|\{color:(?:red|blue|green|gold)\|[^}]+\})/);
    if (parts.length === 1) return text;
    return parts.map((part, i) => {
        if (i % 2 === 0) return part;
        if (part.startsWith('***')) return <strong key={i}><em>{part.slice(3, -3)}</em></strong>;
        if (part.startsWith('**'))  return <strong key={i}>{part.slice(2, -2)}</strong>;
        if (part.startsWith('~~'))  return <StrikethroughSpan key={i}>{part.slice(2, -2)}</StrikethroughSpan>;
        if (part.startsWith('=='))  return <HighlightMark key={i}>{part.slice(2, -2)}</HighlightMark>;
        if (part.startsWith('_'))   return <UnderlineSpan key={i}>{part.slice(1, -1)}</UnderlineSpan>;
        if (part.startsWith('{color:')) {
            const pipeIdx = part.indexOf('|');
            const name = part.substring(7, pipeIdx);
            const colorText = part.substring(pipeIdx + 1, part.length - 1);
            return <ColorSpan key={i} $color={COLOR_VALUES[name]}>{colorText}</ColorSpan>;
        }
        return <em key={i}>{part.slice(1, -1)}</em>;
    });
}
